import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import { action } from 'satcheljs/lib/legacy';
export default action('updateIsEditing')(function updateEditedRecipient(
    oldRecipient: ReadWriteRecipientViewState,
    newRecipient: ReadWriteRecipientViewState
) {
    oldRecipient.persona = newRecipient.persona;
    oldRecipient.displayText = newRecipient.displayText;
    oldRecipient.isValid = newRecipient.isValid;
    oldRecipient.isEditing = false;
});
